/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupResp } from '../../models/group-resp';

export interface ApiManagementGroupGetActiveGet$Params {
}

export function apiManagementGroupGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiManagementGroupGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GroupResp>>> {
  const rb = new RequestBuilder(rootUrl, apiManagementGroupGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GroupResp>>;
    })
  );
}

apiManagementGroupGetActiveGet.PATH = '/api/Management/Group/GetActive';
